// Indian date formatting utility
export const formatIndianDate = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) return 'N/A';

  const parts = new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).formatToParts(date);

  const day = parts.find((p) => p.type === 'day')?.value;
  const month = parts.find((p) => p.type === 'month')?.value;
  const year = parts.find((p) => p.type === 'year')?.value;

  return `${day}-${month}-${year}`;
};

// Indian currency formatting
export const formatIndianCurrency = (amount) => {
  if (amount === null || amount === undefined || amount === '') return '₹0';

  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 2
  }).format(Number(amount));
};

// Compact Indian currency formatting (dashboard-friendly)
export const formatIndianCurrencyCompact = (amount) => {
  if (amount === null || amount === undefined || amount === '') return '₹0';
  const n = Number(amount);
  if (!Number.isFinite(n)) return '₹0';

  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';

  if (abs >= 10000000) {
    const v = abs / 10000000;
    const s = v >= 10 ? v.toFixed(0) : v.toFixed(1);
    return `${sign}₹${s} Cr`;
  }
  if (abs >= 100000) {
    const v = abs / 100000;
    const s = v >= 10 ? v.toFixed(0) : v.toFixed(1);
    return `${sign}₹${s} L`;
  }
  if (abs >= 1000) {
    const v = abs / 1000;
    const s = v >= 10 ? v.toFixed(0) : v.toFixed(1);
    return `${sign}₹${s} K`;
  }

  return `${sign}₹${Math.round(abs)}`;
};

// Indian date-time formatting
export const formatIndianDateTime = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);

  if (Number.isNaN(date.getTime())) return 'N/A';

  const parts = new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }).formatToParts(date);

  const day = parts.find((p) => p.type === 'day')?.value;
  const month = parts.find((p) => p.type === 'month')?.value;
  const year = parts.find((p) => p.type === 'year')?.value;
  const hour = parts.find((p) => p.type === 'hour')?.value;
  const minute = parts.find((p) => p.type === 'minute')?.value;
  const dayPeriod = parts.find((p) => p.type === 'dayPeriod')?.value;

  return `${day}-${month}-${year} ${hour}:${minute} ${dayPeriod}`;
};
